module.exports = __webpack_public_path__ + "img/classify_12.5f421e07.png";